module.exports = __webpack_public_path__ + "img/5-low.4780fe5f.jpg";